import { Button, Empty, Menu, Select } from "antd";
import { firestoreDB } from "config/initializers";
import MrFirebase from "lib/MrFirebase/MrFirebase";
import React, { memo, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { appRegionSelector, currentUserSelector } from "views/Auth/Login/selector";
import { actions as segmentActions } from "views/Segments/redux";
import dayjs from "dayjs";
import {
  CloseOutlined
} from "@ant-design/icons";
import { activeLogsHistoryForSegmentIdSelector } from "../selector";

const SegmentHistory = (props) => {
  const { segmentId, experience, onChange } = props

  const [historyParams, setHistoryParams] = useState({});

  const appRegion = useSelector(appRegionSelector());
  const isChina = appRegion === "china";
  const currentUser = useSelector(currentUserSelector());
  const activeLogsHistoryForSegmentId = useSelector(activeLogsHistoryForSegmentIdSelector());
  const dispatch = useDispatch();

  useEffect(() => {
    showHistory()
  }, [])

  const showHistory = () => {
    let params = {};
    if (isChina) {
      params = {
        log_type: ["eq", "segment"],
        experience_id: ["eq", experience.id],
        item_id: ["eq", segmentId],
      };
    } else {
      params = {
        log_type: ["==", "segment"],
        experience_id: ["==", experience.id],
        item_id: ["==", segmentId],
      };
    }
    setHistoryParams({ ...params });
  }

  const HistoryFilter = (props) => {
    console.log("HistoryFilter props ==>", props);
    return null;
  };


  const HistoryMenu = (props) => {
    const { data = [] } = props
    const defaultHistoryId = data[0] && data[0].id
    const [currentHistoryId, setCurrentHistoryId] = useState(defaultHistoryId);

    let finalHistory = ""

    const handleCancel = () => {
      dispatch(segmentActions.setActiveLogsHistoryForSegmentIdSuccess({
        activeLogsHistoryForSegmentId: null
      }))
      onChange({})
    }

    const onHistoryMenuSelect = (option) => {
      console.log("onHistoryMenuSelect ====>", option);
      let value = {}
      for (let i = data.length - 1; i >= 0; i--) {
        if (data[i].updated_at <= option.updated_at && data[i].values) { 
          value = {
            ...value,
            ...data[i].values,
            child_segment_attributes: {
              ...value.child_segment_attributes,
              ...data[i].values.child_segment_attributes
            }
          }
        }
      }
      setCurrentHistoryId(option.id)
      onChange(value)
    }

    const getHistoryItems = () => {
      return data.map((d) => {
        const description = `${dayjs(d.updated_at).format("MMM DD, YYYY")} ${dayjs(d.updated_at).format("hh:mm:ss a")}, IP: ${d.user_ip}`
        return <Menu.Item key={d.id} className="logs-menu-items" onClick={() => onHistoryMenuSelect(d)}>
          <span>{d.msg}</span>
          <span className="custom-menu-item-description">{description}</span>
        </Menu.Item>
      })
    }

    if (data.length === 0) {
      finalHistory = <Empty description="No logs history" />
    } else {
      finalHistory = <Menu mode="inline" selectedKeys={[`${currentHistoryId}`]} >{getHistoryItems()}</Menu>
    }

    return <div className="history-item">
      Logs History <Button onClick={() => handleCancel()} danger className="logs-modal-cancel-button" icon={<CloseOutlined />}></Button>
      {finalHistory}
    </div>
  }

  let finalRender = ""

  if (activeLogsHistoryForSegmentId !== null && activeLogsHistoryForSegmentId === segmentId) {
    finalRender = <MrFirebase
      firestoreDB={firestoreDB}
      mode={"not-realtime"}
      // default mode is realtime
      filter={HistoryFilter}
      sort={{
        created_at: "desc",
      }}
      list={HistoryMenu}
      currentUser={currentUser}
      experience={experience}
      params={historyParams}
      collectionPath={`orgs/${currentUser.org_id}/logs`}
      tableName={"logs"}
    />
  }

  return finalRender
}

export default memo(SegmentHistory);